import BaseClass from "./BaseClass";
import axios from "axios";

class SharedAmocrm extends BaseClass {
  constructor(data, skip_embedded = false) {
    !data.licenses || delete data.licenses;
    super(data, skip_embedded);
    this._loading = false;
  }

  get schema() {
    return {
      domain: {
        editable: true
      },
      login: {
        editable: true
      },
      password: {
        editable: true,
        props: {
          "show-password": true
        }
      },
      secret_key: {
        editable: false,
        hidden: true,
        props: {
          "show-password": true
        }
      },
      account_id: {
        editable: true
      }
      // confirmed: {
      //     editable: false,
      //     type: Boolean
      // }
    };
  }

  get actions() {
    return {
      open_amo: {
        handler: () => this._handleOpenAmo(),
        props: { type: "default", size: "small" },
        in_edit_mode: false,
        button_els: [require("icons/OpenInNew").default]
      },
      check_amo: {
        handler: () => this._handleCheckAmo(),
        props: { type: "default", size: "small" },
        in_edit_mode: false
      },
      unlink_customer: {
        handler: () => this._handleUnlinkCustomer(),
        props: { type: "danger", size: "small" },
        in_edit_mode: false
      },
      edit: {
        handler: () => Promise.resolve("edit"),
        props: { type: "primary", size: "small" },
        in_edit_mode: false
      },
      save: {
        handler: () => this._handleSave(),
        props: { type: "success", size: "small" },
        in_edit_mode: true
      },
      cancel: {
        handler: () => this._handleCancel(),
        props: { type: "primary", size: "small" },
        in_edit_mode: true
      }
    };
  }

  get sharedCustomersUsers() {
    try {
      return this._embedded.sharedCustomersUsers;
    } catch (e) {
      /**/
    }
    return [];
  }

  get sharedCustomersWidgets() {
    try {
      return this._embedded.sharedCustomersWidgets;
    } catch (e) {
      /**/
    }
    return [];
  }

  get licenses() {
    try {
      // eslint-disable-next-line no-prototype-builtins
      if (!this._embedded.hasOwnProperty("sharedAmocrmLicenses")) {
        throw new Error();
      }
      return this._embedded.sharedAmocrmLicenses;
    } catch (e) {
      this._lazyLoadLicenses();
      return undefined;
    }
  }

  _handleOpenAmo() {
    return axios
      .get(`https://${this.domain}?logout=yes`)
      .catch(() => {})
      .then(() => {
        window.open(
          `https://${this.domain}?USER_LOGIN=${this.login}&USER_HASH=${this.secret_key}`
        );
      });
  }

  _handleCheckAmo() {
    this._loading = true;

    let token = "d5bb90a9adc7491697c49b55b6ad3c75";

    return axios
      .get(`https://teal.bpmcenter.pro/api/v1/validating/${this.uuid}`, {
        headers: {
          Authorization: "Basic " + token
        }
      })
      .then(response => {
        Object.assign(
          this,
          {
            sharedCustomers_uuid: response.data.model["shared-customers_uuid"]
          },
          response.data.model
        );
        delete this["shared-customers_uuid"];

        if (response.data.result.status) {
          this._notify.success("Account credentials correct");
          this._loading = false;
        } else {
          this._notify.error("Account credentials wrong");
          this._loading = false;
        }
      })
      .catch(() => {
        this._loading = false;
      });
  }

  _handleUnlinkCustomer() {
    this.sharedCustomers_uuid = null;
    return this._handleSave(false).then(() => {
      this._notify.success({
        title: "Success",
        message: "Deleted customer relationship"
      });
      return "unlink";
    });
  }

  _handleCancel() {
    return Promise.resolve("cancel");
    // return this._api.query({
    //     query: require("../../graphql/amocrm/amocrm_query.graphql"),
    //     variables: this
    // }).then((res) => {
    //     Object.assign(this, res.data.shared_amocrm);
    //     return "cancel";
    // });
  }

  _handleSave(show_notice = true) {
    return this._api
      .mutate({
        mutation: require("../../graphql/amocrm/amocrm_save.graphql"),
        variables: this
      })
      .then(res => {
        let errors;
        try {
          errors = res.data.shared_amocrm.errors;
        } catch (e) {
          /**/
        }
        if (errors) {
          errors.forEach((e, i) => {
            setTimeout(
              () =>
                this._notify.error({
                  title: "Duplicate",
                  message: e
                }),
              150 * i
            );
          });
          return "not saved";
        }
        if (show_notice) {
          this._notify.success({
            title: "Success",
            message: "Saved amo account"
          });
        }
        return "save";
      });
  }

  async _lazyLoadLicenses() {
    if (
      this._embedded &&
      typeof this._embedded.sharedAmocrmLicenses !== "undefined"
    ) {
      return;
    }
    this._embedded || this._set(this, "_embedded", {});
    this._embedded.sharedAmocrmLicenses ||
      this._set(this._embedded, "sharedAmocrmLicenses", {});
    if (!this.sharedAmocrmLicenses_uuid) {
      return;
    }
    return await this._api
      .query({
        query: require("../../graphql/amo_licenses/shared_amocrm_licenses_query.graphql"),
        variables: { uuid: this.sharedAmocrmLicenses_uuid }
      })
      .then(res => {
        this._log(res.data.shared_amocrm_licenses);
        this._set(
          this._embedded,
          "sharedAmocrmLicenses",
          res.data.shared_amocrm_licenses
        );
      })
      .catch((...args) => {
        this._log(...args);
      });
  }
}

export default SharedAmocrm;
